import React from 'react';
import classNames from 'classnames';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { useSelector } from 'react-redux';

import { emailRegex, states, formStyles } from '../../../constants/SiteVariables';
import BeneficialOwnerRecord from '../../../records/beneficial_owner';
import ColumnInput from '../../shared/ColumnInput';
import StickyInput from '../../shared/StickyInput';
import StickySelect from '../../shared/StickySelect';

export default function BeneficialOwnerCreate({toggleAddOwner, addOwner}) {
  const isLoading = useSelector(state => state.sessions.get('loading'));

  const saveNewOwners = values => {
    addOwner(new BeneficialOwnerRecord(values));
  };

  return (
      <div className="columns is-centered">
        <div className="column">
          <Formik
            initialValues={(new BeneficialOwnerRecord()).toJS()}
            validate={async (values) => {
              const errors = {};
              const addNested = (field, msg) => errors['address'] = { ...errors['address'], [field]: msg };

              if (!values.address.address1) addNested('address1', '* Required');
              if (!values.address.city) addNested('city', '* Required');
              if (!values.address.state) addNested('state', '* Required');
              if (!values.address.zip) {
                addNested('zip', '* Required');
              } else if(values.address.zip.trim().length < 5) {
                addNested('zip', '* Must be 5 characters in length');
              }

              if (!values.first_name) errors.first_name = '* Required';
              if (!values.last_name) errors.last_name = '* Required';
              if (!values.dob) errors.dob = '* Required';
              if (!values.ssn) {
                errors.ssn = '* Required';
              } else if (values.ssn.replace(/[^\d]/g, '').length < 9) {
                errors.ssn = '* Must be 9 characters in length';
              }
              if (!values.email) errors.email = '* Required';
              if (!emailRegex.test(values.email)) errors.email = 'Please provide a valid email address'

              return errors;
            }}
            onSubmit={(values, { setSubmitting }) => {
              saveNewOwners(values);
            }}
          >
            {({ isSubmitting, errors }) => (
              <Form role="form">
                <ColumnInput error={errors.first_name}>
                  <StickyInput
                    id="first_name"
                    placeholder="First Name"
                    styles="is-half"
                  />

                  <StickyInput
                    error={errors.last_name}
                    id="last_name"
                    placeholder="Last Name"
                    styles="is-half"
                  />
                </ColumnInput>

                <ColumnInput error={errors.dob}>
                  <StickyInput
                    id="dob"
                    mask="99/99/9999"
                    placeholder="DOB (mm/dd/yyyy)"
                    styles="is-half"
                  />

                  <StickyInput
                    error={errors.ssn}
                    id="ssn"
                    mask="999-99-9999"
                    placeholder="SSN"
                    styles="is-half"
                  />
                </ColumnInput>

                <ColumnInput error={errors.email}>
                  <StickyInput
                    id="email"
                    type="email"
                    placeholder="Email Address"
                  />
                </ColumnInput>

                <ColumnInput error={errors.address && errors.address.address1}>
                  <StickyInput
                    id="address.address1"
                    placeholder="Street Address"
                    styles="is-mobile"
                  />
                </ColumnInput>

                <ColumnInput error={errors.address && errors.address.city}>
                  <StickyInput
                    id="address.city"
                    placeholder="City"
                  />

                  <StickySelect
                    error={errors.address && errors.address.state}
                    id="address.state"
                    options={states}
                    placeholder="State"
                  />

                  <StickyInput
                    error={errors.address && errors.address.zip}
                    id="address.zip"
                    mask="99999"
                    placeholder="Zip"
                  />
                </ColumnInput>

                <div className="buttons">
                  <button
                    type="button"
                    role="submit"
                    disabled={isSubmitting}
                    onClick={toggleAddOwner}
                    className={classNames('button is-danger is-outlined', {
                      'is-loading': isLoading
                    })}>
                    Cancel
                  </button>

                  <button
                    type="submit"
                    role="submit"
                    disabled={isSubmitting}
                    className={classNames('button is-primary', {
                      'is-loading': isLoading
                    })}>
                    Save
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
  )
}
